import React, {Component} from "react"
import PropTypes from "prop-types"
import {isEmpty} from "lodash"
import History from "@irati/utils/history"

import getId from "@irati/utils/id"
import authentication from "@irati/auth"
import Loading from "@irati/ui/src/Loading"
import {ENABLED} from "@irati/insights/constants/schedule"
import {injectIntl} from "@irati/utils/lang"

import {PageWithStickyFooter} from "../../../components/Layout"
import {getSchedule, updateSchedule} from "../../../graph/schedule"
import {Validate} from "../../../components/Wizard/Validate"
import {notifyError} from "../../../helpers/general"
import sitemap from "../../../routes/sitemap"
import {Breadcrumbs} from "../../Navigation"

class ValidateController extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    scheduleId: PropTypes.string.isRequired,
    renderFooter: PropTypes.func.isRequired,
    backToRoute: PropTypes.string.isRequired,
    formatMessage: PropTypes.func.isRequired,
    isEdit: PropTypes.bool
  }

  static defaultProps = {
    isEdit: false
  }

  static contextTypes = {
    appPath: PropTypes.string.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      load: new Promise(() => {}),
      buttonLoad: false,
      schedule: {}
    }
  }

  componentDidMount() {
    this.init()
  }

  init = () => {
    const tenant = authentication.userTenant().uuid
    const {scheduleId} = this.props
    const load = getSchedule({tenant, id: scheduleId, withInterest: true, withQuestions: true, withValidationErrors: true}).then(
      (schedule) => this.setState({schedule})
    )
    this.setState({load})
  }

  handleUpdateSchedule = () => {
    const {formatMessage} = this.props
    const {
      schedule: {id, tenant, Etag}
    } = this.state
    const params = {id, tenant, Etag, status: ENABLED}
    const buttonLoad = updateSchedule({schedule: params, withValidationErrors: true})
      .then(() => History.push(sitemap.homepage.url, this.context))
      .catch((error) => notifyError(error, formatMessage))
    this.setState({buttonLoad})
  }

  render() {
    const idNamespace = getId("ValidateController", this.props)
    const {load, schedule, buttonLoad} = this.state
    const {match, renderFooter, backToRoute, isEdit} = this.props
    const crumbs = [sitemap.homepage, isEdit ? sitemap.scheduleEditSummary : sitemap.wizardStep3]
    return (
      <PageWithStickyFooter id={idNamespace} footerChildren={renderFooter(schedule, this.handleUpdateSchedule, buttonLoad)}>
        <Breadcrumbs id={idNamespace} crumbs={crumbs} match={match} />
        <Loading load={load}>{!isEmpty(schedule) && <Validate id={idNamespace} schedule={schedule} backToRoute={backToRoute} />}</Loading>
      </PageWithStickyFooter>
    )
  }
}

export default injectIntl(ValidateController)
